import countryList from "@/data/countries.json";
import { EXCLUDED_COUNTRIES } from "@/lib/constants";

export const FREQUENT_COUNTRIES = countryList.filter(({ isoCode }) =>
  [
    "US",
    "GB",
    "AU",
    "BE",
    "CA",
    "DE",
    "FR",
    "HK",
    "JP",
    "MY",
    "NZ",
    "NL",
    "SE",
    "FI",
    "ES",
  ].includes(isoCode)
);

export const ALL_COUNTRIES = countryList.filter(
  ({ isoCode }) => !EXCLUDED_COUNTRIES.includes(isoCode)
);

export const RecipientCountryOptions = () => {
  return (
    <>
      <optgroup label="Frequent Picks">
        {FREQUENT_COUNTRIES.map((country) => (
          <option key={country.isoCode} value={country.isoCode}>
            {country.name}
          </option>
        ))}
      </optgroup>
      <optgroup label="All">
        {ALL_COUNTRIES.map(({ name, isoCode }) => (
          <option key={isoCode} value={isoCode}>
            {name}
          </option>
        ))}
      </optgroup>
    </>
  );
};
